export default "/images/13.png?a6740b28ff23e94639804b2ad7efeaa0";